const appConfig = {
    apiPrefix: process.env.REACT_APP_API_URL,
    environment: process.env.REACT_APP_ENVIRONMENT,
    authenticatedEntryPath: '/',
    unAuthenticatedEntryPath: '/not-available',
    mockApi: false
}

export default appConfig
